// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__pk1G3","text":"style_text__ENaog","actions":"style_actions__VNOBW","actions_btn":"style_actions_btn__rIY0v"};